import { Role } from '@core/referential/role.enum'

export enum Permission {
  PATRIMONY_SITES = 'patrimony_sites',
  PATRIMONY_USERS = 'patrimony_users',
  SITE_GENERAL = 'site_general',
  ALERT_CONFIGURATION = 'alert-configuration',
  REPORT_CONFIGURATION = 'report_configuration',
  SITE_INFORMATION = 'site_information',
  SITE_EQUIPMENT = 'site_equipment',
  SITE_ACTION_ASSIGNATION = 'site_action_assignation',
  SITE_DEVICES = 'site_devices',
  SITE_DASHBOARD = 'site_dashboard',
  COMPANY_SETTINGS = 'company_settings',
  MY_ACTIONS = 'my_actions',
  EDIT_ALL = 'edit_all',
  EDIT_FLOOR_PLAN = 'edit_floor_plan',
  VMC_CONFIGURATION = 'vmc_configuration',
}

export function userPermission(role: Role, permission: Permission): boolean {
  switch (permission) {
    case Permission.PATRIMONY_SITES: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.PATRIMONY_USERS: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.SITE_GENERAL: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.ALERT_CONFIGURATION: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.REPORT_CONFIGURATION: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.SITE_INFORMATION: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.SITE_ACTION_ASSIGNATION: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.SITE_EQUIPMENT: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.SITE_DEVICES: {
      return [Role.ADMIN, Role.ADMIN_SITE, Role.MANAGER].includes(role)
    }

    case Permission.COMPANY_SETTINGS: {
      return [Role.ADMIN, Role.ADMIN_SITE].includes(role)
    }

    case Permission.MY_ACTIONS: {
      return role !== Role.OPERATOR_RESTRICTED
    }

    case Permission.EDIT_ALL: {
      return role !== Role.OPERATOR_RESTRICTED
    }

    case Permission.EDIT_FLOOR_PLAN: {
      return [Role.SUPER_ADMIN, Role.ADMIN, Role.ADMIN_SITE].includes(role)
    }

    // Configuration du synoptique VMC : création et ordre des étages, rattachement des VMC. Réservée aux
    // administrateurs, en phase avec les rôles acceptés par PUT /site/{siteId}/vmc/configuration —
    // ADMIN_SITE en est exclu des deux côtés.
    case Permission.VMC_CONFIGURATION: {
      return [Role.SUPER_ADMIN, Role.ADMIN].includes(role)
    }

    default: {
      return false
    }
  }
}
